import React from "react";
import Form from "react-bootstrap/Form";

const SwCheckbox = ({
  id,
  name,
  label,
  checked,
  defaultChecked,
  disabled = false,
  inline = false,
  onChange,
  className = "",
  ...rest
}) => {
  return (
    <Form.Check
      type="checkbox"
      id={id}
      name={name}
      label={label}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      inline={inline}
      onChange={onChange}
      className={className}
      {...rest}
    />
  );
};

export default SwCheckbox;
